import { ENV_DETAILS } from "@bridgesplit/utils";

// fine to expose publicly
export const AUTH_DOMAIN = ENV_DETAILS.authDomain;
export const AUTH_CLIENT_ID = ENV_DETAILS.authClient;
